import { cloneDeep } from 'lodash';
import * as types from '../actions/actionTypes';
import { SELECT_GEOGRAPHICS_TAB_OPTIONS } from '../components/geoMap/GeoMapConstant';
import initialState from './initialState';

export default (state = initialState.geomap, action) => {
  switch (action.type) {
    case types.CLEAR_GEOMAP_REPORTS_SAMPLE_WEIGHTED: {
      const keyType = `${action.targetGrid}Data`;
      const recycleElements = state.RecycleGridData
        ? [...state.RecycleGridData]
        : [];
      const selectedGridData = state[keyType] ? [...state[keyType]] : [];
      const geographicsTableApiQueues = cloneDeep(
        state.geographicsTableApiQueues
      );
      return {
        ...state,
        [keyType]: [],
        uuid: action.uuid,
        RecycleGridData: [...selectedGridData, ...recycleElements],
        originalTitles: {
          ...state.originalTitles,
          [action.targetGrid]: {},
        },
        geographicsTableApiQueues:
          keyType === 'TargetDataGridData'
            ? action.updatedGeographicsTableApiQueuesList
            : geographicsTableApiQueues,
      };
    }

    case types.SET_GEOMAP_BASE_TARGET: {
      const keyType = `${action.targetGrid}Data`;
      return {
        ...state,
        [keyType]: [action.payload],
        uuid: action.uuid,
      };
    }
    case types.FETCH_GEOMAPPING_SMART_SEARCH_KPI: {
      const savedKPIs = { ...state.allSelectedKPIsInfo };
      const sampleWeightedKPIs = { ...state.sampleWeightedKPIs };
      const selectedKPIsTitle = { ...state.selectedKPIsTitle };
      const kpiExpression = action.payload.kpiExpression || {};

      for (const key in kpiExpression) {
        selectedKPIsTitle[key] = kpiExpression[key];
      }

      action.payload.expressionList.forEach((item, index) => {
        savedKPIs[item] = {
          modeled: action.payload.response[index]
            ? action.payload.response[index].modeled
            : false,
          productNo: action.payload.productNo,
        };
        sampleWeightedKPIs[item] = {
          productNo: action.payload.productNo,
          data: action.payload[index] ? [action.payload[index]] : [],
        };
      });
      return {
        ...state,
        allSelectedKPIsInfo: savedKPIs,
        kpiInfo: {
          ...action.payload[0],
          expressionList: action.payload.expressionList[0],
        },
        sampleWeightedKPIs,
        selectedKPIsTitle,
      };
    }

    case types.UPDATE_TARGET_SAMPLE_AND_WEIGHT: {
      if (state.TargetDataGridData.length > 0) {
        return {
          ...state,
          TargetDataGridData: [
            {
              keyword: action.payload.targetInfo.keyword,
              title: action.payload.targetInfo.title,
              originalTitle: action.payload.targetInfo.originalTitle,
              sample: action.payload[0].intab,
              weighted: action.payload[0].weighted,
            },
          ],
        };
      }
      break;
    }

    case types.REMOVE_GEOMAP_KPI: {
      return {
        ...state,
        kpiInfo: undefined,
      };
    }

    case types.UPDATE_SELECTED_GEOGRAPHICS_TAB: {
      return {
        ...state,
        selectedGeographicsTabIndex: action.payload,
      };
    }

    case types.FETCH_GEOGRAPHICS_DATA: {
      const key = `${action.selectedTab}`;
      return {
        ...state,
        geographicsData: {
          ...state.geographicsData,
          [key]: action.payload,
        },
      };
    }

    case types.SET_GEOGRAPHICS_TABLE_DATA: {
      const key = `${action.selectedTab}`;
      return {
        ...state,
        geographicsTableData: {
          ...state.geographicsTableData,
          [key]: action.payload,
        },
      };
    }

    case types.FETCH_GEOGRAPHICS_TABLE_API_QUEUES: {
      const key = `${action.selectedTab}`;
      return {
        ...state,
        geographicsTableApiQueues: {
          ...state.geographicsTableApiQueues,
          [key]: action.payload,
        },
      };
    }

    case types.RESET_GEOGRAPHICS_TAB_API_QUEUES: {
      const key = `${action.selectedTab}`;
      return {
        ...state,
        geographicsTableApiQueues: {
          ...state.geographicsTableApiQueues,
          [key]: action.payload,
        },
      };
    }

    case types.RESET_GEOGRAPHICS_TABLE_DATA_APIS_API_QUEUES: {
      return {
        ...state,
        geographicsTableApiQueues: action.geographicsTableApiQueues,
        geographicsTableData: action.geographicsTableData,
      };
    }

    case types.UPDATE_COUNTY_AND_ZIPCODE_CATEGORY: {
      if (action.payload.selectedTab === 'county') {
        return {
          ...state,
          countyCategorySelectedVal: action.payload.selectedCategory,
        };
      }
      return {
        ...state,
        zipcodeCategorySelectedVal: action.payload.selectedCategory,
      };
    }

    case types.DELETE_GEOGRAPHIES_TABLE_DATA: {
      const {
        updatedGeographyData,
        selectedTabVal,
        updatedGeographicsTableApiQueues,
      } = action.payload;
      const geographicsSortOrder = cloneDeep(state.geographicsSortOrder);
      return {
        ...state,
        geographicsTableData: {
          ...state.geographicsTableData,
          [selectedTabVal]: updatedGeographyData,
        },
        geographicsTableApiQueues: {
          ...state.geographicsTableApiQueues,
          [selectedTabVal]: updatedGeographicsTableApiQueues,
        },
        geographicsSortOrder: {
          ...state.geographicsSortOrder,
          [selectedTabVal]:
            updatedGeographyData.length > 0
              ? geographicsSortOrder[selectedTabVal]
              : {},
        },
      };
    }

    case types.UPDATE_PARENT_DRAGGED_NODES: {
      return {
        ...state,
        draggedParentNodes: {
          ...state.draggedParentNodes,
          [action.selectedTab]: [
            ...state.draggedParentNodes[action.selectedTab],
            ...action.payload,
          ],
        },
      };
    }

    case types.UPDATE_GEOMAP_SORT_DATA: {
      const { selectedTabVal, updatedGeographicsSortOrder } = action.payload;
      return {
        ...state,
        geographicsSortOrder: {
          ...state.geographicsSortOrder,
          [selectedTabVal]: updatedGeographicsSortOrder,
        },
      };
    }

    case types.SET_PARENT_CHILD_COUNT_MAP: {
      return {
        ...state,
        parentChildCountMap: {
          ...state.parentChildCountMap,
          [action.selectedTab]: {
            ...action.payload,
          },
        },
      };
    }

    case types.SET_EXTRACTED_NODES: {
      return {
        ...state,
        allGeoNodesToCompare: {
          ...state.allGeoNodesToCompare,
          [action.selectedTab]: action.payload,
        },
      };
    }

    case types.UPDATE_GEOMAP_TARGET_AND_BASE_ON_STUDY_CHANGE: {
      return {
        ...state,
        TargetDataGridData: action.targetInfo,
        BaseDataGridData: action.baseInfo,
      };
    }

    case types.UPDATE_GEOMAP_SAMPLE_WEIGHTED: {
      const keyType = `${action.targetGrid}Data`;
      const keywordArr = [];
      const gridData = [];
      const titleArr = [];
      action.gridData.forEach(elems => {
        if (
          keywordArr.indexOf(elems.keyword.trim()) === -1 ||
          titleArr.indexOf(elems.title.trim()) === -1
        ) {
          keywordArr.push(elems.keyword.trim());
          titleArr.push(elems.title.trim());
          gridData.push(elems);
        }
      });
      return {
        ...state,
        [keyType]: [...gridData],
      };
    }

    case types.SET_ORIGINAL_TITLE: {
      return {
        ...state,
        originalTitles: {
          ...state.originalTitles,
          [action.targetGrid]: { ...action.payload },
        },
      };
    }

    case types.SET_GEOGRAPHIES_COUNT: {
      return {
        ...state,
        geographicsCount: {
          ...state.geographicsCount,
          [action.selectedTab]: action.payload,
        },
      };
    }

    case types.RESET_GEOGRAPHICS_TABLE_DATA_WITH_ZEROES: {
      return {
        ...state,
        geographicsTableData: action.geographicsTableData,
      };
    }

    case types.SET_EXP_API_QUEUE: {
      return {
        ...state,
        expApiQueue: [...action.payload],
      };
    }

    case types.RESET_EXP_API_QUEUE: {
      return {
        ...state,
        expApiQueue: [],
      };
    }

    case types.EXPORT_PROGRESS_WARNING_MSG_FLAG:
      return {
        ...state,
        exportSpinnerWarningInfoMsg: action.payload,
      };

    case types.SET_EXPORT_SPINNER_FLAG:
      return {
        ...state,
        exportSpinnerProgressFlag: action.payload,
      };

    case types.SET_GEOGRAPHICS_TABLE_API_CALL_STATUS: {
      const key = `${action.selectedTab}`;
      return {
        ...state,
        geographicsTableApiQueues: {
          ...state.geographicsTableApiQueues,
          [key]: action.payload,
        },
      };
    }

    case types.UPDATE_GEO_MAP_SETTINGS:
      const currentTab = [
        SELECT_GEOGRAPHICS_TAB_OPTIONS[state.selectedGeographicsTabIndex].value,
      ];
      return {
        ...state,
        mapSettings: {
          ...state.mapSettings,
          [currentTab]: {
            ...state.mapSettings[currentTab],
            [action.key]: action.value,
          },
        },
      };
    case types.UPDATE_COMPLETE_GEO_MAP_SETTINGS:
      return {
        ...state,
        mapSettings: action.data,
      };
    case types.LOADING_GEO_MAP_TABLE_DATA:
      return {
        ...state,
        isGeoMapTableDataLoading: action.value,
      };

    default:
      return state;
  }
};
